import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitLayoutsSidePanel.module.scss';

const SidePanel = ({ component, className, testId }) => (
  <section
    className={classnames(styles.element, className)}
    data-testid={testId}
  >
    {component}
  </section>
);

SidePanel.defaultProps = {
  className: '',
  testId: '',
};

SidePanel.propTypes = {
  className: PropTypes.string,
  component: PropTypes.shape({}).isRequired,
  testId: PropTypes.string,
};

export default SidePanel;
